import React, { useEffect, useState } from "react";
import { Subfolder } from "../../../redux/interfaces/folder.types.ts";
import { useAppSelector } from "../../../redux/hooks.ts";
import {
  groupByStatus,
  groupBySubfolder,
} from "../../../utils/base-requirements/requirements/groupByRequirements.ts";
import { DetailedView } from "./DetailedView.tsx";
import { CollapseFolderRequirements } from "../../folders/CollapseFolderRequirements.tsx";
import { AddBaseRequirement } from "../AddBaseRequirement.tsx";
import { SwitchRequirementsView } from "../../folders/SwitchRequirementsView.tsx";

interface Props {
  subfolders: Subfolder[];
}

export const View: React.FC<Props> = ({ subfolders }) => {
  const [groupRequirements, setGroupRequirements] = useState<any>({});

  const { activeFolder } = useAppSelector((state) => state.folder);
  const { activeRequirement, groupType } = useAppSelector(
    (state) => state.requirements,
  );

  const requirements = subfolders.flatMap(
    (subfolder) => subfolder.requirements,
  );
  const requirementsByStatus = groupByStatus(requirements);
  const requirementsBySubfolder = groupBySubfolder(subfolders);

  const handleGroupTypeChange = () => {
    if (groupType === "status") {
      setGroupRequirements(requirementsByStatus);
    }
    if (groupType === "subfolder") {
      setGroupRequirements(requirementsBySubfolder);
    }
  };

  useEffect(() => {
    handleGroupTypeChange();
  }, [groupType, activeFolder]);

  return (
    <div className="w-full border-none">
      <div className="w-full flex justify-center items-center mb-4">
        <SwitchRequirementsView />
      </div>
      <div className="flex flex-row w-full border-none shadow-none">
        <CollapseFolderRequirements
          activeRequirement={activeRequirement}
          activeFolder={activeFolder}
          groupRequirements={groupRequirements}
        />
        <div className={`p-8 ${activeRequirement ? "w-7/12" : "w-0"}`}>
          {!!activeRequirement && <DetailedView />}
        </div>
      </div>
      <div>
        <AddBaseRequirement subfolders={subfolders!} />
      </div>
    </div>
  );
};
